<div class="card mb-3">
  <div class="card-body">
    <p class="card-text">{{ name }}</p>
    <h5 class="card-title">
      {{ value }}
    </h5>
  </div>
</div>
